import { render, staticRenderFns } from "./DomeTransactionalInfo.vue?vue&type=template&id=0c685794&"
import script from "./DomeTransactionalInfo.vue?vue&type=script&lang=ts&"
export * from "./DomeTransactionalInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports